module.exports = __webpack_public_path__ + "glyphicons-halflings.2516339970d710819585.png";


//////////////////
// WEBPACK FOOTER
// /usr/local/app/src/assets/Bootstrap/img/glyphicons-halflings.png
// module id = ../../../../../src/assets/Bootstrap/img/glyphicons-halflings.png
// module chunks = 2